/* global gtag, YT */
import {articles} from './shared.js';
import {buttonDown, buttonUp} from './intro.js';

/**
 * Track an event with a label
 * @param {String} event event
 * @param {String} label label
 */
function track(event, label) {
  console.log(`tracking: ${event} / ${label}`);
  gtag('event', event, {'event_label': label});
}

let unvisitedArticles = new Set(articles);

window.addEventListener('scroll', function visitor() {
  unvisitedArticles.forEach(article => {
    const {top, bottom} = article.getBoundingClientRect();
    if (top <= 0 && bottom >= 0) {
      unvisitedArticles.delete(article);
      track('depth', article.dataset.chapter);
    }
  });

  if (unvisitedArticles.size === 0) {
    window.removeEventListener('scroll', visitor);
    unvisitedArticles = null;
  }
}, {passive: true});

buttonUp.addEventListener('click', () => track('intro', 'lead-up'));
buttonDown.addEventListener('click', () => track('intro', 'aftermath'));

for (const cta of [document.querySelector('#promo'), document.querySelector('.trailer-cta')]) {
  cta.addEventListener('click', evt => {
    evt.stopPropagation();
    track('cta', 'click');
  });
}
